<template>
	<div>
		<sui-modal v-model="open" size="fullscreen">
			<sui-modal-header>
				<slot name="titulo">
					<strong class="blackFont"
						>{{ editar ? 'Editar' : 'Crear' }} examen</strong
					>
				</slot>
				<i
					style="float: right; cursor: pointer;"
					class="close icon"
					@click="close"
				></i>
			</sui-modal-header>
			<sui-modal-content scrolling>
				<sui-modal-description>
					<div class="ui two column grid">
						<div class="column">
							<sui-form @submit.prevent>
								<sui-form-fields fields="two">
									<BaseInput
										v-model="examen.clave"
										titulo="Clave"
										placeholder="Clave"
										class="field"
										type="text"
										:error="erroresValidacion && !validationClave"
										:disabled="editar"
									></BaseInput>
									<BaseInput
										v-model="examen.nombre"
										titulo="Nombre"
										placeholder="Nombre"
										class="field"
										type="text"
										:error="erroresValidacion && !validationNombre"
									></BaseInput>
								</sui-form-fields>
								<sui-form-fields fields="two">
									<div class="field">
										<label class="boldfont">Fecha inicial</label>
										<flat-pickr
											v-model="examen.fechaInicio"
											:config="configDate"
											placeholder="Seleccione la fecha inicial"
											name="date"
										/>
										<div style="margin-top: 5px;">
											<span
												v-show="erroresValidacion && !validationFechaInicio"
												:class="$style.danger"
											>
												<sui-icon name="exclamation circle" />Dato obligatorio
											</span>
										</div>
									</div>
									<div class="field">
										<label class="boldfont">Hora inicial(24hr)</label>
										<flat-pickr
											v-model="examen.horaInicio"
											:config="configTime"
											placeholder="Seleccione la hora inicial"
											name="time"
										/>
										<div style="margin-top: 5px;">
											<span
												v-show="erroresValidacion && !validationHoraInicio"
												:class="$style.danger"
											>
												<sui-icon name="exclamation circle" />Dato obligatorio
											</span>
										</div>
									</div>
								</sui-form-fields>
								<sui-form-field>
									<BaseTextArea
										v-model="examen.introduccion"
										titulo="Introducción"
										placeholder="Introducción"
										class="field fluid"
										:error="erroresValidacion && !validationIntroduccion"
										:rows="
											examen.introduccion
												? examen.introduccion.split('\n').length
												: 1
										"
									></BaseTextArea>
								</sui-form-field>

								<base-button
									class="boldFont submit"
									style-button="primary"
									style-class="right floated"
									:loading="loading"
									type="submit"
									@click.native="toggle"
									>Guardar</base-button
								>
							</sui-form>
						</div>
						<div class="column">
							<h4>Previsualización introducción</h4>
							<label>
								<base-mostrar-markdown
									style="display: inline-block;"
									:contenido="examen.introduccion"
								/>
							</label>
						</div>
					</div>
				</sui-modal-description>
			</sui-modal-content>
		</sui-modal>
	</div>
</template>
<script>
import _ from 'lodash';
import { mapGetters, mapMutations } from 'vuex';
import { formatDateInput, formatDateTimeInput } from '@utils/format-date';
export default {
	props: {
		loading: {
			type: Boolean,
			default: false
		},
		editar: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			open: false,
			examen: {},
			configDate: {
				dateFormat: 'Y-m-d'
			},
			configTime: {
				enableTime: true,
				noCalendar: true,
				dateFormat: 'H:i',
				time_24hr: true
			},
			erroresValidacion: false
		};
	},
	computed: {
		...mapGetters('examenes', ['getExamen']),
		validationClave() {
			return this.examen.clave !== undefined && this.examen.clave.trim() !== '';
		},
		validationFechaInicio() {
			return (
				this.examen.fechaInicio !== undefined &&
				this.examen.fechaInicio.trim() !== ''
			);
		},
		validationHoraInicio() {
			return (
				this.examen.horaInicio !== undefined &&
				this.examen.horaInicio.trim() !== ''
			);
		},
		validationNombre() {
			return (
				this.examen.nombre !== undefined && this.examen.nombre.trim() !== ''
			);
		},
		validationIntroduccion() {
			return (
				this.examen.introduccion !== undefined &&
				this.examen.introduccion.trim() !== ''
			);
		}
	},
	watch: {
		open(val) {
			if (!val) {
				this.erroresValidacion = false;
				this.SET_EXAMEN({});
				this.$emit('input', {});
			}
		},
		getExamen(val) {
			if (!_.isEmpty(val) && this.editar) {
				this.examen = {
					clave: val.clave,
					nombre: val.nombre,
					horaInicio: formatDateTimeInput(val.fechaYHoraInicio).format('HH:mm'),
					fechaInicio: formatDateInput(val.fechaYHoraInicio).format(
						'YYYY-MM-DD'
					),
					introduccion: val.introduccion
				};
				this.$emit('input', this.examen);
			} else {
				this.examen = {};
			}
		}
	},
	mounted() {},
	methods: {
		...mapMutations('examenes', ['SET_EXAMEN']),
		toggle($event) {
			event.preventDefault();
			if (this.open) {
				if (
					this.validationClave &&
					this.validationNombre &&
					this.validationFechaInicio &&
					this.validationHoraInicio &&
					this.validationIntroduccion
				) {
					this.erroresValidacion = false;
					this.$emit('input', this.examen);
					if (this.editar) {
						this.$emit('editar');
					} else {
						this.$emit('guardar');
					}
				} else {
					this.erroresValidacion = true;
				}
			} else {
				this.open = !this.open;
			}
		},
		close() {
			this.open = false;
		},
		aceptar() {}
	}
};
</script>

<style lang="scss" module>
@import '@design';
.danger {
	color: $background-danger;
}
</style>
